import React, { forwardRef } from "react";
import PropTypes from 'prop-types';
import { TableRow, TableCell, IconButton } from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';
import { useInView } from "react-intersection-observer";
import BulletStatus from "../Common/BulletStatus";
import { TooltipRight, TooltipTop } from "../Common/CustomTooltips";
import {
  setGradeColor,
  trophyIcons,
  trophyDescriptions,
  selectTrophySize,
  selectCellByTrophyCount
} from "../../utils/helpers";
import t from "../../languages/pl";

const DriverRow = forwardRef(({ data, onDetailsClick, classes, onEcoGradeClick }, ref) => {
  const [observe, inView] = useInView();

  return (
    <TableRow ref={ref} className={classes.driverRowHeight}>
      <TableCell ref={observe} className={classes.driverNameRowCell}>
        {inView ? data.kierowca_nazwa : null}
      </TableCell>

      {inView ? <TableCell className={selectCellByTrophyCount(classes, data.trofeum)}>
        <React.Fragment>
          <TooltipTop
            title={trophyDescriptions[data.trofeum]}
          >
            <img
              src={trophyIcons[data.trofeum]}
              className={selectTrophySize(classes, data.trofeum)}
            />
          </TooltipTop>
        </React.Fragment>
      </TableCell> : null}

      {inView ? <TableCell className={classes.cell}>
        {data.kierowca_rfid}
      </TableCell> : null}

      {inView ? <TableCell className={classes.cell}>
        {data.kierowca_telefon}
      </TableCell> : null}

      {inView ? <TableCell className={classes.cell}>
        {data.kierowca_email}
      </TableCell> : null}

      {inView ? <TableCell className={classes.cell}>
        {data.kierowca_opis_rejon}
      </TableCell> : null}

      {inView ? <TableCell className={classes.cell}>
        {data.kierowca_opis_poza_rejon}
      </TableCell> : null}

      {inView ? <TableCell className={classes.cell}>
        {data.kierowca_grupa.nazwa}
      </TableCell> : null}

      {inView ? <TableCell className={classes.cell}>
        <TooltipRight title={t.showEcoChart} disable={data.kierowca_eco === null}>
          <BulletStatus
            background={setGradeColor(data.kierowca_eco)}
            onClick={() => onEcoGradeClick(data.kierowca_id)}
          >
            {data.kierowca_eco === -1 ? 'b.d.' : data.kierowca_eco}
          </BulletStatus>
        </TooltipRight>
      </TableCell> : null}

      {inView ? <TableCell className={classes.cell}>
        <IconButton onClick={() => onDetailsClick(data.kierowca_id)}>
          <ListIcon/>
        </IconButton>
      </TableCell> : null}
    </TableRow>
  );
});

DriverRow.displayName = "DriverRow";

DriverRow.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object,
  onDetailsClick: PropTypes.func,
  onEcoGradeClick: PropTypes.func,
  onTrophyHover: PropTypes.func,
};

export default DriverRow;